import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormInstance } from 'actions/templates';
import { FIELD_TITLE, FIELD_DESCRIPTION, FIELD_TEXT, FIELD_TEXTAREA } from 'constants/fields';
import { Spinner } from 'UI';
import './Styles.scss';
var DisplayFormResults = /*#__PURE__*/function (_Component) {
  /* Class setup */
  function DisplayFormResults(props) {
    var _this;
    _classCallCheck(this, DisplayFormResults);
    _this = _callSuper(this, DisplayFormResults, [props]);
    /* Lifecycle methods */
    _defineProperty(_this, "componentDidMount", function () {
      if (_this.props.instance != null) {
        _this.props.getFormInstance(_this.props.instance.id).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });
    /* Render methods */
    _defineProperty(_this, "renderTitle", function (field) {
      return /*#__PURE__*/React.createElement("div", {
        className: "input-label"
      }, field.value);
    });
    _defineProperty(_this, "renderDescription", function (field) {
      return /*#__PURE__*/React.createElement("div", null, field.value);
    });
    _defineProperty(_this, "renderInput", function (field) {
      var activeInstance = _this.props.activeInstance;
      var type = field.type.toLowerCase();
      var value = null;
      if (activeInstance != null) {
        var findResult = activeInstance.fieldResults.find(function (result) {
          return result.fieldName == field.name;
        });
        if (findResult != null) {
          value = findResult.value;
        }
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "placeholder-input ".concat(type)
      }, value);
    });
    _defineProperty(_this, "renderField", function (field, index) {
      if (field.type == FIELD_TITLE) {
        return /*#__PURE__*/React.createElement("div", {
          key: 'field-' + index,
          className: "form-row field"
        }, _this.renderTitle(field, index));
      }
      if (field.type == FIELD_DESCRIPTION) {
        return /*#__PURE__*/React.createElement("div", {
          key: 'field-' + index,
          className: "form-row field"
        }, _this.renderDescription(field, index));
      }
      return /*#__PURE__*/React.createElement("div", {
        key: 'field-' + index,
        className: "form-row"
      }, _this.renderInput(field, index));
    });
    _this.state = {
      loading: true
    };
    return _this;
  }
  _inherits(DisplayFormResults, _Component);
  return _createClass(DisplayFormResults, [{
    key: "render",
    value: function render() {
      if (this.props.fields == null) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "dynamic-form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form form-component"
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.props.fields.map(this.renderField)));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeInstance: state.Templates.instance
  };
}
export default connect(mapStateToProps, {
  getFormInstance: getFormInstance
})(DisplayFormResults);